export default "__VITE_ASSET__e8b05de7__"